/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_codes_copy_code = /** @type {(inputs: {}) => string} */ () => {
	return `Kopírovat kód`
};

const da_discount_codes_copy_code = /** @type {(inputs: {}) => string} */ () => {
	return `Kopiér kode`
};

const de_discount_codes_copy_code = /** @type {(inputs: {}) => string} */ () => {
	return `Code kopieren`
};

const en_discount_codes_copy_code = /** @type {(inputs: {}) => string} */ () => {
	return `Copy code`
};

const es_discount_codes_copy_code = /** @type {(inputs: {}) => string} */ () => {
	return `Copiar código`
};

const fr_discount_codes_copy_code = /** @type {(inputs: {}) => string} */ () => {
	return `Copier le code`
};

const hu_discount_codes_copy_code = /** @type {(inputs: {}) => string} */ () => {
	return `Kód másolása`
};

const it_discount_codes_copy_code = /** @type {(inputs: {}) => string} */ () => {
	return `Copia il codice`
};

const nl_discount_codes_copy_code = /** @type {(inputs: {}) => string} */ () => {
	return `Code kopiëren`
};

const pl_discount_codes_copy_code = /** @type {(inputs: {}) => string} */ () => {
	return `Skopiuj kod`
};

const pt_discount_codes_copy_code = /** @type {(inputs: {}) => string} */ () => {
	return `Copiar código`
};

const sv_discount_codes_copy_code = /** @type {(inputs: {}) => string} */ () => {
	return `Kopiera kod`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_codes_copy_code = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_codes_copy_code(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_codes_copy_code", locale)
	if (locale === "cs") return cs_discount_codes_copy_code(inputs)
	if (locale === "da") return da_discount_codes_copy_code(inputs)
	if (locale === "de") return de_discount_codes_copy_code(inputs)
	if (locale === "en") return en_discount_codes_copy_code(inputs)
	if (locale === "es") return es_discount_codes_copy_code(inputs)
	if (locale === "fr") return fr_discount_codes_copy_code(inputs)
	if (locale === "hu") return hu_discount_codes_copy_code(inputs)
	if (locale === "it") return it_discount_codes_copy_code(inputs)
	if (locale === "nl") return nl_discount_codes_copy_code(inputs)
	if (locale === "pl") return pl_discount_codes_copy_code(inputs)
	if (locale === "pt") return pt_discount_codes_copy_code(inputs)
	return sv_discount_codes_copy_code(inputs)
};
export { discount_codes_copy_code as "discount_codes.copy_code" }